import type { UiTheme } from "../theme";

// The ONE attenuated-help-text recipe: ink3 + sizes.sm, the reduced-vision
// floor (DS-16) for instructional/secondary text under a title or label.
// Was hand-copied identically in Settings/settingsCardStyles.ts (cardHelp),
// Progress/progressViewStyles.ts (cardHelp), Progress/ProgressRecordsCard.tsx
// (cardHelp) and Progress/InfoPill.tsx (caption, PG-34). §CONSOLIDAMENTO says
// to build the primitive instead of adding the copy.
// Sibling of makeCardBoxStyle: a style helper, not a component, so each
// call site can still merge its own local differences (e.g. marginTop).
export function helpTextStyle(theme: UiTheme) {
  const { palette: p, typography: t } = theme;
  return {
    color: p.ink3,
    fontSize: t.sizes.sm,
  } as const;
}
